module.exports = __webpack_public_path__ + "static/media/logo.42b67f9b.svg";